export default{
    
    lista:{
        method:'get',
        url:'carta/demissao/lista'
    },
    pesquisa:{
        method:'get',
        url:'boletins/tabela/pesquisa{/id}'
    },
    cadastra:{
        method:'post',
        url:'carta/demissao/cadastro'
    },
    delete:{
        method:'delete',
        url:'carta/demissao/deletar{/id}'
    },
    editar:{
        method:'get',
        url:'carta/demissao/editar{/id}'
    },
    update:{
        method:'post',
        url:'carta/demissao/update'
    },
    numero:{
        method:'post',
        url:'boletins/cartaoponto/numero/max'
    }
}